import { useMemo } from 'react'
import { type SimpleSelectOption } from '@workwave-tidal/core/components'
import { useTexts } from './useTexts'

export function useOptions() {
  const texts = useTexts()

  return useMemo<SimpleSelectOption<string>[]>(() => {
    const options = optionsId.map(value => {
      switch (value) {
        case 'NO_REPEAT':
          return { value, label: texts.noRepeat }
        case 'DAILY':
          return { value, label: texts.daily }
        case 'WEEKLY':
          return { value, label: texts.weekly }
        case 'MONTHLY':
          return { value, label: texts.monthly }
        case 'ANNUALLY':
          return { value, label: texts.annually }
      }
    })

    return [{ value: mixOptionId, label: texts.mix, disabled: true }, ...options]
  }, [texts])
}

const optionsId = ['NO_REPEAT', 'DAILY', 'WEEKLY', 'MONTHLY', 'ANNUALLY'] as const
export const mixOptionId = 'mix'
